import { Component } from '@angular/core';
import { ContentCardService } from '../../../dashboard/services/content-card.service';
import { CardModele } from '../../../dashboard/modeles/cardModele';

@Component({
  selector: 'app-status-preautorisation',
  templateUrl: './status-preautorisation.component.html',
  styleUrls: ['./status-preautorisation.component.scss'],
  standalone: false
})
export class StatusPreautorisationComponent {
  constructor(private readonly _contentCardService: ContentCardService) {}

  getPreAutorisationData(): CardModele {
    return this._contentCardService.cards.find((card: CardModele) => card.titre === 'dashboard.card-trois.titre');
  }
}
